import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { createEntitySlice, getAllRequest, serializeAxiosError } from '../shared/reducers/reducer.utils';

const apiUrl = 'api/profase-workflow-instancias/estado-nodos';

function extractErrorMessage(error: any, fallback: string): string {
  const data = error?.response?.data;
  return data?.details ?? data?.detail ?? data?.message ?? data?.title ?? error?.message ?? fallback;
}

export const getEntities = createAsyncThunk(
  'workflowInstanciaEstadoNodos/fetch_entity_list',
  async (request: any) => {
    const params = getAllRequest(request);
    return axios.get<any>(`${apiUrl}?${params}&cacheBuster=${new Date().getTime()}`);
  },
  { serializeError: serializeAxiosError },
);

/** Dashboard: counts by nodoEstado */
export const getResumen = createAsyncThunk(
  'workflowInstanciaEstadoNodos/fetch_resumen',
  async () => {
    return axios.get<any[]>(`${apiUrl}/resumen?cacheBuster=${new Date().getTime()}`);
  },
  { serializeError: serializeAxiosError },
);

export const WorkflowInstanciaEstadoNodosSlice = createEntitySlice({
  name: 'workflowInstanciaEstadoNodos',
  skipRejectionHandling: true,
  initialState: {
    loading: false,
    errorMessage: null,
    entities: [],
    entity: {},
    updating: false,
    totalItems: 0,
    updateSuccess: false,
    resumen: [] as any[],
    loadingResumen: false,
  } as any,
  extraReducers(builder) {
    builder
      .addCase(getResumen.pending, state => {
        const s = state as any;
        if (!Array.isArray(s.resumen) || s.resumen.length === 0) {
          s.loadingResumen = true;
        }
      })
      .addCase(getResumen.fulfilled, (state, action) => {
        const s = state as any;
        s.loadingResumen = false;
        s.resumen = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(getResumen.rejected, state => {
        const s = state as any;
        s.loadingResumen = false;
        if (!Array.isArray(s.resumen) || s.resumen.length === 0) {
          s.resumen = [];
        }
      })
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const body = action.payload.data;
        const content = Array.isArray(body) ? body : (body?.content ?? []);
        const total = Array.isArray(body)
          ? parseInt(action.payload.headers['x-total-count'] ?? '0', 10)
          : (body?.totalElements ?? 0);
        return {
          ...state,
          loading: false,
          entities: content,
          totalItems: total,
        };
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isRejected(getEntities), (state, action) => {
        state.loading = false;
        state.updateSuccess = false;
        state.errorMessage = extractErrorMessage(action.error, 'Error al cargar actividades');
      });
  },
});

export const { reset } = WorkflowInstanciaEstadoNodosSlice.actions;
export default WorkflowInstanciaEstadoNodosSlice.reducer;
